declare const ENVARS: any;

const constants = (key: string): string => ENVARS.APP[key] || process.env[`REACT_APP_${key}`] + '';

export { constants };
